module.exports = __webpack_public_path__ + "static/media/coffee-promo-mb-fr.7f313e26.jpg";